/**
 * Simple plugin that handles the loading bar actions
 *
 * This plugin uses delegate events so it's independent of the sections.
 */

export default class LoadingBar {
  constructor () {
    this.element = document.querySelector('.loadingBar');

    document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
    document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));

    this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
  }

  _onLoadingStart() {
    this.element.classList.add('is-visible');
    this.element.style.width = '40%';
  }
  _onLoadingEnd() {
    this.element.style.width = '100%';
    this.element.classList.add('is-finished');
  }
  _onTransitionEnd(event) {
    if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
      this.element.classList.remove('is-visible');
      this.element.classList.remove('is-finished');
      this.element.style.width = '0';
    }
  }
}